import component from './ThemePicker.vue'
export default component
